import allShopPage from "./allShopPage"
export default allShopPage;
